export const unstable_settings = {
  initialRouteName: 'cart/index',
};

export { default } from 'navigation/layouts/cart-layout';
